<template>
	<div
		class="color-block"
		:style="`height: ${size}px; background-color: ${hex};`"
	></div>
</template>

<script>
export default {
	name: "ColorBlock",

	props: ["hex", "size"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.color-block {
	border: 1px solid #eee;
	height: 25px;
	width: 75px;
}
</style>
